export enum FamilyStatus {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
}

export const formatFamilyStatus = (status: FamilyStatus): string => {
  const statusLabels: Record<FamilyStatus, string> = {
    [FamilyStatus.PENDING]: "ממתין",
    [FamilyStatus.ACTIVE]: "פעיל",
    [FamilyStatus.CLOSED]: "סגור",
  };
  return statusLabels[status] || status;
};

export interface Family  {
    id: number;
    name: string;
    favorites_rank?: number;
    has_question?: boolean;
    requires_attention?: boolean;
    status?: FamilyStatus;
    updated_at?: Date | string | null;
  }
  

  export enum FamilyMembershipType {
    Contributor = "contributor",
    Dependant = "dependant",
  }
  
  export interface FamilyMember  {
    id: number;
    contact_id: number;
    family_id: number;
    family_membership_type: FamilyMembershipType;
  }

  export interface FamilyCreateDTO {
    name: string;
    members: Omit<FamilyMember, "id" | "family_id">[];
  }
  
  export interface FamilyWithMembers extends Family {
    members: FamilyMember[];
  }